import {WatchableObject} from './WatchableObject.js';

/**
 * The current state of the application. When the state changes, AppState dispatches a CHANGE
 * event. To change the application state, use AppStateUpdate instances.
 */
export class AppState extends WatchableObject {
  constructor () {
    super();
    // The application state
    this.state = null;
  }
}
